module.exports = __webpack_public_path__ + "img/effect.d950231c.png";